import React, { FC } from "react"
import { graphql } from "gatsby"
import { Tooltip } from "react-tooltip"

import { addThousandCommas, generateConditionalClassName } from "@utils"

import Button, { BUTTON_VARIANTS } from "@components/Button/Button"

import { PricingPlanCardDIV } from "./PricingPlanCard.styles"
import { PricingTablePlanFragmentFragment } from "@graphqlTypes"

type PricingPlanCardProps = {
  plan: PricingTablePlanFragmentFragment
  hideButton?: boolean
  usePrimaryButton?: boolean
}

const PricingPlanCard: FC<PricingPlanCardProps> = ({
  plan,
  hideButton,
  usePrimaryButton,
}) => {
  return (
    <>
      <PricingPlanCardDIV className={generateConditionalClassName({
        "hide-button": !!hideButton,
        "plan": true,
        [`plan--${plan.id}`]: true,
      })}>
        <div className="gradient-background" />
        <h4 className="type--headline-medium-XL margin-bottom--0">{plan.name}</h4>
        <p className="plan-description type--text-S color--text-headline margin-bottom--0">
          {plan.id === "free" ? (
            <strong>Up to {addThousandCommas(plan.maxContacts || 0)} contacts</strong>
          ) : (
            <strong>Starts with {addThousandCommas(plan.baseContacts || 0)} contacts</strong>
          )}
          <br />
          and unlimited users
        </p>
        {!hideButton && (
          <Button
            href={plan.ctaLink || "/"}
            variant={!usePrimaryButton ? BUTTON_VARIANTS.SECONDARY : undefined}
          >
            {plan.ctaText || ""}
          </Button>
        )}
      </PricingPlanCardDIV>
      <Tooltip
        className="font-family--sans font-size--S"
        float
        id={`Tooltip--PricingTable-contacts--${plan.id}`}
        place="bottom"
      >
        A person who receives a response or resolves an AI query in a billing period.
      </Tooltip>
    </>
  )
}

export default PricingPlanCard
